import '../../../../packages/frontend/components/arti24/arti24-stats-link.js';
import '../../../../packages/frontend/components/arti24/arti24.js';
import '../../../../packages/frontend/components/menu/menu-init.js';
import '../../../../packages/frontend/components/menu/Menu.js';
import '../../../../packages/frontend/DrivingLicenseCostCalculator.js';
import '../../../../packages/frontend/LegalLetter.js';
import '../../../../packages/frontend/PkkChecklist.js';
import { initSiteSearch } from '../../../../packages/frontend/components/search/SiteSearch.js';
import { TrafficJourney } from '../../../../packages/frontend/TrafficJourney.js';
import { animateBrandArrival } from './brand-arrival.js';
import { initDisclosureMenu } from './disclosure-menu.js';
import { initLegalWatchExport } from './legal-watch-export.js';
import { initLegalWatchImport } from './legal-watch-import.js';
import { initLegalWatchReview } from './legal-watch-review.js';

void animateBrandArrival();
initSiteSearch();

new TrafficJourney({
    outboundDomains: ['kopama.pl'],
}).init();

declare global {
    interface Window {
        setSiteTheme: (mode: string) => void;
    }
}

// The header toggle has its own click handler; keep its state in sync after automatic changes.
const themeRoot = document.documentElement;
const themeButton = document.querySelector<HTMLButtonElement>('#site-theme-toggle')!;
const syncThemeControl = () => {
    themeButton.setAttribute('aria-pressed', String(themeRoot.dataset.theme === 'dark'));
};
new MutationObserver(syncThemeControl).observe(themeRoot, {
    attributes: true,
    attributeFilter: ['data-theme'],
});
syncThemeControl();

document.querySelectorAll<HTMLElement>('[data-ps-disclosure]').forEach(initDisclosureMenu);
document.querySelectorAll<HTMLElement>('[data-legal-watch-export]').forEach(initLegalWatchExport);
document.querySelectorAll<HTMLFormElement>('[data-legal-watch-review]').forEach(initLegalWatchReview);
document.querySelectorAll<HTMLFormElement>('[data-legal-watch-import]').forEach(initLegalWatchImport);

// Keep keyboard navigation inside the shared menu while its drawer is open.
const menuRoot = document.querySelector<HTMLElement>('[data-menu9]');
menuRoot?.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || !menuRoot.classList.contains('menu9-is-open')) return;
    const focusable = Array.from(
        menuRoot.querySelectorAll<HTMLElement>('[data-menu9-side] :is(a, button, summary)'),
    ).filter((element) => element.getClientRects().length && element.tabIndex >= 0);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
    }
});

// The contents remain server-rendered; the observer marks the section currently being read.
const tocLinks = Array.from(document.querySelectorAll<HTMLAnchorElement>('.toc__list a'));
const tocSections = tocLinks
    .map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
    .filter((section): section is HTMLElement => section !== null);
if (tocSections.length) {
    const markCurrentSection = () => {
        const current =
            [...tocSections].reverse().find((section) => section.getBoundingClientRect().top <= 160) || tocSections[0];
        tocLinks.forEach((link) => {
            if (decodeURIComponent(link.hash.slice(1)) === current.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
        });
    };
    new IntersectionObserver(markCurrentSection, { rootMargin: '-80px 0px -60% 0px' }).observe(tocSections[0]);
    window.addEventListener('scroll', markCurrentSection, { passive: true });
    markCurrentSection();
}
